import React from 'react';

const Footer = () => {
  return (
    <div className='footer-container'>
      <div className='footer-content'>
        <p>Designed and Built by Nik Stires</p>
        <p>
          Made With{' '}
          <a
            href='https://tinyurl.com/yyfjy2g2'
            target='_blank'
            rel='noreferrer'
          >
            Curiosity
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Footer;
